import { ErgoRoleInterface } from '../models/ergo-role.model';
import { RoleInterface } from '../models/role.model';

import { RoleActions, RoleActionType } from './actions/role-actions.enum';
import { RoleStateInterface } from './role-state.model';

const initialState: RoleStateInterface = {
  roles: undefined,
  ergoRoles: undefined,
};

export function roleReducer(state: RoleStateInterface = initialState, action: RoleActions): RoleStateInterface {
  switch(action.type) {
    case RoleActionType.LoadRolesComplete:
      return {
        ...state,
        roles: action.payload as RoleInterface[],
      };

    case RoleActionType.LoadErgoRolesComplete:
      return {
        ...state,
        ergoRoles: action.payload as ErgoRoleInterface[],
      };

    default: return state;
  }
}
